<template>
  <v-dialog v-model="dialogIsOpen" max-width="450px">
    <v-card class="d-flex flex-column pt-16 px-16 rounded-lg" min-height="50vh">
      <v-card-text class="my-auto d-flex flex-column align-center">
        <p class="text-center font-weight-medium text-subtitle-1 px-4">
          {{ $t('message.appointmentCancelled') }}
        </p>
      </v-card-text>

      <v-card-actions class="d-flex flex-column align-stretch">
        <app-button invert gradient :label="$t('button.makeNewAppointment')" :to="{ name: $constants.ROUTE_NAME.APPOINTMENT_MAKE_APPOINTMENT }" class="py-5 mb-12" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['value'],

  computed: {
    dialogIsOpen: {
      get() {
        return this.value
      },
      set(isOpen) {
        !isOpen && this.$emit('input', isOpen)
      }
    }
  },

  methods: {
    redirectToAppointments() {
      this.$router.push({ name: this.$constants.ROUTE_NAME.APPOINTMENT_MY_APPOINTMENT })
    }
  }
}
</script>
